// extracted by mini-css-extract-plugin
export default {"about":"About_about__tm0go","hero":"About_hero__O+Ym+","heroInner":"About_heroInner__OK9dI","section":"About_section__mF69c","grid":"About_grid__bpyiY","card":"About_card__HzdwH"};